var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 16.0001C30.0008 16.3397 29.9138 16.6736 29.7473 16.9696C29.5808 17.2655 29.3406 17.5133 29.05 17.6889L11.04 28.7064C10.7364 28.8923 10.3886 28.9938 10.0326 29.0004C9.67661 29.007 9.32532 28.9184 9.015 28.7439C8.70764 28.572 8.4516 28.3214 8.2732 28.0178C8.09481 27.7142 8.00051 27.3685 8 27.0164V4.98389C8.00051 4.63174 8.09481 4.28609 8.2732 3.98247C8.4516 3.67886 8.70764 3.42824 9.015 3.25639C9.32532 3.08182 9.67661 2.99326 10.0326 2.99985C10.3886 3.00645 10.7364 3.10795 11.04 3.29389L29.05 14.3114C29.3406 14.487 29.5808 14.7348 29.7473 15.0307C29.9138 15.3266 30.0008 15.6606 30 16.0001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayFill);
export default __webpack_public_path__ + "static/media/play-fill.897fdf91450c348b4af6b09911d32e0d.svg";
export { ForwardRef as ReactComponent };